import React from "react";
import {Icon28CheckCircleOutline, Icon28ErrorCircleOutline, Icon28InfoCircleOutline} from "@vkontakte/icons";

const typeConfig = {
    error: {
        className: "bg-brand-danger text-white",
        icon: <Icon28ErrorCircleOutline />,
    },
    success: {
        className: "bg-brand-success text-white",
        icon: <Icon28CheckCircleOutline />,
    },
    info: {
        className: "bg-brand-primary text-white",
        icon: <Icon28InfoCircleOutline />,
    },
};

// Toast - всплывающее сообщение, которое не блокирует игровой процесс
export const Toast = ({text, type = "info", onClose}) => {
    const config = typeConfig[type] ?? typeConfig.info;

    return (
        <div className="fixed inset-x-0 top-4 z-50 flex justify-center px-4 pointer-events-none">
            <div
                className={`pointer-events-auto flex items-center gap-2 rounded-xl px-4 py-3 shadow-lg backdrop-blur ${config.className}`}
                onClick={onClose}
                role="status"
                aria-live="polite"
            >
                <span className="[&>svg]:h-5 [&>svg]:w-5">{config.icon}</span>
                <span className="text-sm font-medium leading-tight">{text}</span>
            </div>
        </div>
    );
};
